{
  "id": 24,
  "location": "paris",
  "difficulty": "normal",
  "moves": 12,
  "kinds": 5,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "croissant", "count": 28 }
  ],
  "stars": [3730, 5130],
  "board": [
    ". . . . . . . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . ~. ~. ~. ~. . .",
    ". . . # # . . .",
    ". . . # # . . .",
    ". . ~. ~. ~. ~. . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.718, "movesLeft": 3.1, "closeLosses": 0.16, "target": 0.7 }
}
